import React from 'react';
import { useState, useEffect} from "react";
import {CommonDialogBox} from "components";
import {Stack, DialogProps, InputLabel, ListSubheader, Tooltip } from '@mui/material';
import Select from '@mui/material/Select';
import { Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useDispatch, useSelector} from 'react-redux';
import { closeIndexedPointDialog} from 'store/main/viewObjects';
import { RootState } from 'store';
import { styled } from "@mui/material/styles";
import { getCachedData } from "api/Cache";
import axios from 'axios';
import AuthService from "services/AuthService";
import jwtService from 'services/jwtService';
import NotificationMsg from "../NotificationMsg";
import { config } from "config";
import NotificationModel from 'components/notificationPanel/model/NotificationModel';
import { addNotification } from 'components/notificationPanel/store/dataSlice';
import EventsEmitter from "events/EventsEmitter";
import {rawDataSources} from "constants/common";
import { trackEvent } from 'components/Tracking';

function IndexedPoint(props:any){
    const org = config.org;
    const { project, catalogId, file_type, name, isFolder} = props;
    const dispatch = useDispatch();
    const data = getCachedData();

    const viewObject = useSelector((state: RootState) => state.main.viewObject);
    const { objSources, objName, objType, iptstate:open } = viewObject;

    //console.log("Milko Sources : " + JSON.stringify(objSources))


    const [itemName, setItemName] = useState(`New ${name}`)
    const [itemNameError, setItemNameError] = useState(false)
    const [helperItemName, setHelperItemName] = useState('')
  
    
    const [source, setSource] = useState([])
    const [captureDate, setCaptureDate] = useState<any>(null)
    const [horizontalDatum, setHorizontalDatum] = useState('')
    const [verticalDatum, setVerticalDatum] = useState('')
    const [projections, setProjections] = useState('')
    const [horizontalUnits, setHorizontalUnits] = useState('')
    const [verticalUnits, setVerticalUnits] = useState('')
    const [fileDate, setFileDate] = useState('')

    const [coordOriginX, setCoordOriginX] = useState('')
    const [coordOriginY, setCoordOriginY] = useState('')
    const [coordOriginZ, setCoordOriginZ] = useState('')
    const [voxelSize, setVoxelSize] = useState('')
       
    const closeComposeDialog: DialogProps["onClose"] = (event, reason) => {
        if (reason && reason === "backdropClick")
            return;

        if(reason === "escapeKeyDown")
             cancel()
    }

	const cancel = () => {
        trackEvent("Process", "Indexed Point", "Close");
        dispatch(closeIndexedPointDialog({}))
        setSource([])
	}
 
    const handleName = (e:any) => {
        setItemName(e.target.value)
        console.log(e.target.value)
        if(e.target.value === ''){
            setItemNameError(true);
            setHelperItemName("Please select a name");
        }else{
            setItemNameError(false);
            setHelperItemName("");
        }
    }
   
    const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
        "&:hover": {
            backgroundColor: "#1275aa", // light blue hover
            color: "#fff",
        },
        "&.Mui-selected": {
            backgroundColor: "#fff",
            position: "relative",
        },
        "&.Mui-selected:hover": {
            backgroundColor: "#1275aa",
            color: "#fff"
        },
        "&.Mui-selected::after": {
            content: '""',
            position: "absolute",
            right: 12,
            top: "50%",
            transform: "translateY(-50%)",
            width: 16,
            height: 16,
            backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='black' viewBox='0 0 24 24'><path d='M20.285 6.709l-11.285 11.293-5.285-5.293 1.41-1.41 3.875 3.879 9.875-9.879z'/></svg>")`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
        },
    }));
    
    const projectFiles = objSources.filter(
        (item: any) => item.file_folder === "0" && item.type === objType
    );

    const folderItems = objSources
    .filter((item: any) => item.type === "FOLDER" && item.project === project)
    .flatMap((folder: any) => {
        const files = objSources.filter(
            (item: any) => item.file_folder === folder.id && item.type === objType
        );

        if (files.length === 0) return [];

        return [
            <MenuItem disabled key={`${folder.id}-header`}>
                {folder.name.toUpperCase()}
            </MenuItem>,
            ...files.map((file: any) => (
                <CustomMenuItem value={file.id} key={file.id}>
                    {file.name}
                </CustomMenuItem>
            )),
            <div style={{ margin:'5px 0', borderTop : '1px solid #ededed' }}></div>
        ];
    });

    // Combine folderItems and projectFiles
    const allMenuItems = [
        ...folderItems,
        ...(projectFiles.length > 0
            ? [
                <MenuItem disabled key="project-header">PROJECT CONTENTS</MenuItem>,
                ...projectFiles.map((file: any) => (
                    <CustomMenuItem value={file.id} key={file.id}>
                        {file.name}
                    </CustomMenuItem>
                )),
            ]
            : []),
    ];
  
    
    const DialogAction = () => {
        return (
            <>
                <Button onClick={cancel}>Cancel</Button>
                <Button 
                    variant="contained"
                    color="primary"
                    type="submit" onClick={() => {
                        trackEvent("Process", "Indexed Point", "Create");
                        create();
                    }}
                >
                    Create
                </Button>
            </>
        )
    }


    const create = async () => {
       
        const payload = {
            name: itemName,
            source : source.join(" "),
            capture_date: Date.now().toString(),
            type: "FILE",
            state: "PARTIAL",
            file_type: file_type,
            file_size: "0",
            file_date: fileDate,
            file_folder: isFolder ? catalogId : "0",
            coord_origin_x: coordOriginX,
            coord_origin_y: coordOriginY,
            coord_origin_z: coordOriginZ,
            coord_hdatum: horizontalDatum,
            coord_vdatum: verticalDatum,
            coord_projection: projections,
            coord_projection_tm_falseEasting: "0.0",
            coord_projection_tm_falseNorthing: "0.0",
            coord_projection_tm_latOriginDeg: "0.0",
            coord_projection_tm_longMeridianDeg: "0.0",
            coord_projection_tm_scaleFactor: "0.0",
            coord_projection_lcc_falseEasting: "0.0",
            coord_projection_lcc_falseNorthing: "0.0",
            coord_projection_lcc_latOfOriginDeg: "0.0",
            coord_projection_lcc_longOfOriginDeg: "0.0",
            coord_projection_lcc_firstStdParallelDeg: "0.0",
            coord_projection_lcc_secondStdParallelDeg: "0.0",
            coord_projection_aeac_falseEasting: "0.0",
            coord_projection_aeac_falseNorthing: "0.0",
            coord_projection_aeac_latOfOriginDeg: "0.0",
            coord_projection_aeac_longOfOriginDeg: "0.0",
            coord_projection_aeac_firstStdParallelDeg: "0.0",
            coord_projection_aeac_secondStdParallelDeg: "0.0",
            coord_projection_amg_zone: "48",
            coord_unit: horizontalUnits,
            voxel_size: voxelSize
        }

        const response = await jwtService.fetchRequest({
			method: 'POST',
			url: `/entity.ashx?project=${project}`,
			data: payload,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
		});

		const data = response.data;

         if(data.result === 'success') {
            const id = data.id;
            const formData = new FormData();
            formData.append("process", `IMPORT_${file_type}`);

            const response = await axios.post(`/events.ashx?project=${project}&id=${id}&org=${org}`, formData, {
            headers: { 
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${AuthService.getToken()}`,
                },
            });

            if(response.data.result === 'success'){
                dispatch(addNotification(NotificationModel({ message: <NotificationMsg msg={itemName}/>, options: { variant: 'success' } })));
                EventsEmitter.emit("reloadData", "");
            }else{
                dispatch(addNotification(NotificationModel({ message: 'An error occurs during the process upload', options: { variant: 'error' } })));
            }

        }else{
            dispatch(addNotification(NotificationModel({ message: 'An error occurs during the process upload', options: { variant: 'error' } })));
        }
              
        setTimeout(() => {
            dispatch(closeIndexedPointDialog({}))
        }, 100);
        
    }

    useEffect(() => {     

        const projects: any = data["projects"][project];
        setCaptureDate(Date.now())
        setHorizontalDatum(projects['coord_hdatum'])
        setVerticalDatum(projects['coord_vdatum'])
        setProjections(projects['coord_projection'])
        setHorizontalUnits(projects['coord_unit'])
        setVerticalUnits(projects['coord_unit'])
        setFileDate(projects['file_date'])
        setCoordOriginX(projects['coord_origin_x'])
        setCoordOriginY(projects['coord_origin_y'])
        setCoordOriginZ(projects['coord_origin_z'])
        setVoxelSize(projects['voxel_size'])
    }, [data, project])

    
    return (
		<>
            <CommonDialogBox
                classes={{
                    paper: 'm-24 rounded-8 white-bg'
                }}
                open={open}
                handleClose={closeComposeDialog}
                fullWidth
                maxWidth="sm"
                subtitle1={`New ${objName}`}
                titleh5=''
                dialogAction={objSources.filter((item:any) => item.type === objType && item.project === project).length > 0 ? <DialogAction /> : ''}
                displayScrollBar={true}
                maxHeight={600}
                helpLinkCode="project-objects-indexed-point-cloud"
            >   
                {
                objSources.filter((item:any) => item.type === objType && item.project === project).length > 0 ?         
                <Stack 
                    gap={1}
                >
                    <InputLabel id="itemName-label">Name</InputLabel>
                    <Tooltip title="A clear, descriptive name for the new Indexed Point Cloud entity." placement="top" arrow>
                        <TextField
                            id="itemName"
                            name="itemName"
                            error={itemNameError}
                            helperText={helperItemName}
                            value={itemName}
                            type="txt"
                            fullWidth
                            color='primary'
                            variant="outlined"
                            inputProps={{
                                style: {
                                height: '5px',
                                },
                            }}
                            onChange={handleName}
                        /> 
                    </Tooltip>                  
                    <InputLabel id="voxsurf-select-pc-label">Source Point Cloud</InputLabel>

                    <Tooltip title="Select a raw Point Cloud from the list. This will serve as the input for the indexing process." placement="top" arrow>
                        <Select
                            required
                            margin="dense"
                            id="voxsurf-select-pc"
                            name="voxsurf-select-pc"
                            label="Source"
                            value={source}
                            multiple
                            displayEmpty
                            fullWidth
                            color="primary"
                            variant="outlined"
                            onChange={(e: any) => setSource(e.target.value)}
                            sx={{
                                    '& .MuiSelect-multiple': {
                                display: 'flex',
                                    justifyContent: 'left',   // centers horizontally
                                    textAlign: 'center',        // centers multiline text
                                    alignItems: 'center',       // centers vertically
                                    paddingLeft: '15px',
                                    paddingRight: 0,
                                    },
                                    '& .MuiChip-root': {
                                    height: '20px',
                                    fontSize: '0.75rem',
                                    margin: '2px',
                                    },
                                }}
                            >
                            {
                                allMenuItems
                            }
                        
                        
                        </Select>
                    </Tooltip>
                </Stack>
                :
                <div style={{display:'flex', justifyContent:'center',alignItems: 'center', height: '30vh'}}>
                    {                      
                    `No "${rawDataSources[objType]}" data source found`
                    }
                </div>
                }
            </CommonDialogBox>
		</>
  	)
}

export default IndexedPoint